import React from "react";
import PropTypes from "prop-types";
import HoverableTooltip from "components/UI/Tooltip/HoverableTooltip";

const BuyTotalStocksCard = (props) => {
  const { buyTotalCount, totalCount, evaluation, form } = props;

  const { percToGain: wantedPercGain, days: wantedDays } =
    form.getFieldsValue();

  return (
    <div className="flex gap-2 items-center pb-2">
      <div className="flex items-center gap-2">Buy/Total:</div>

      <div>{evaluation ? evaluation?.toFixed(2) : 0}%</div>
      {buyTotalCount ? (
        <div>
          {buyTotalCount} / {totalCount}
        </div>
      ) : (
        ""
      )}
      <HoverableTooltip
        text={`Number of times there actually was a ${wantedPercGain}% gain in ${wantedDays} bars`}
      />
    </div>
  );
};

BuyTotalStocksCard.propTypes = {
  buyTotalCount: PropTypes.number,
  totalCount: PropTypes.number,
  evaluation: PropTypes.number,
  form: PropTypes.object,
};

export default BuyTotalStocksCard;
